import React from 'react';
import { Button } from '../Button/Button';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

export const ConfirmSaveModal = ({ isOpenConfirmSaveModal, setIsOpenConfirmSaveModal, sendRouteEditForm }) => {
  const handleSendRouteEditForm = () => {
      setIsOpenConfirmSaveModal(false);

      sendRouteEditForm();
  }

  const toggle = () => setIsOpenConfirmSaveModal(!isOpenConfirmSaveModal);

  return (
    <Modal isOpen={isOpenConfirmSaveModal} toggle={toggle}>
      <ModalHeader>{__('routes.confirmed_arrived')}</ModalHeader>
        <ModalBody>
            <p>
                {__('routes.confirm_save_approved_arrived')}
            </p>
            <p>
                {__('routes.approved_arrived_sign')}
            </p>
        </ModalBody>
        <ModalFooter>
          <Button className="btn-primary" onClick={handleSendRouteEditForm}>
            {__('app.submit')}
          </Button>
          <Button className="btn-secondary" onClick={() => setIsOpenConfirmSaveModal(false)}>
            {__('app.back')}
          </Button>
        </ModalFooter>
    </Modal>
  );
};
